import { ChangeEvent, useEffect, useState } from 'react';

import { TextField } from '@mui/material';

import { INumericFieldProps } from '../../../constants/types';

const NumericField = ({ value, question, setAnswer }: INumericFieldProps) => {
  const inputValue = Array.isArray(value) ? value.join(', ') : value || '';
  const [tempAnswer, setTempAnswer] = useState<string>('');

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTempAnswer(event.target.value);
  };

  const handleBlur = () => {
    setAnswer(tempAnswer);
  };

  useEffect(() => {
    setTempAnswer(inputValue);
  }, [inputValue]);

  return (
    <TextField
      data-testid="numericfield-option-component"
      label={question.label}
      placeholder={question.placeholder || ''}
      value={tempAnswer}
      onChange={handleChange}
      onBlur={handleBlur}
      type="number"
      fullWidth
      sx={{ mb: 3 }}
    />
  );
};

export default NumericField;
